<script setup lang="ts">
import { computed } from 'vue';

import { LocalScope } from '#public_ts/components';

import { formUrl, isActive, useGlobalSeacrh } from '../util';

const { flattenPanels } = useGlobalSeacrh();
const ROOT = __ROOT__;
const APP_VERSION_QS = __APP_VERSION_QS__;
const mainItems = [
    'manageFactures',
    'fatturaSuperFacile',
    'fatturaStazioneServizioSuperFacile',
    'users',
    'products',
];
const hasMoreItems = computed(() => [...flattenPanels.value.values()].filter((x) => {
    if(x.panel === 'Utente') return false;
    if(mainItems.includes(x.id)) return false;
    return true;
}));

</script>

<template>
    <nav class="bottom-nav">
        <a
            class="bottom-nav-item"
            :href="`${ROOT}Enrollment/index.shtml`"
            :class="isActive(`${ROOT}Enrollment/index.shtml`) ? 'active' : ''"
        >
            <i class="bi bi-house" />
            <span class="bottom-nav-label">Home</span>
        </a>

        <LocalScope v-slot="{ scope: xfm }" :scope="flattenPanels.get('manageFactures')">
            <a
                v-if="xfm"
                class="bottom-nav-item"
                :href="formUrl(xfm.path)"
                :class="isActive(formUrl(xfm.path)) ? 'active' : ''"
            >
                <i class="bi bi-folder" />
                <span class="bottom-nav-label">{{ xfm.label }}</span>
            </a>
        </LocalScope>

        <LocalScope
            v-slot="{ scope: xfm }"
            :scope="flattenPanels.get('fatturaSuperFacile') || flattenPanels.get('fatturaStazioneServizioSuperFacile')"
        >
            <div
                v-if="xfm"
                class="bottom-nav-item bottom-nav-action-button-container"
            >
                <a
                    :href="formUrl(xfm.path)"
                    :class="isActive(formUrl(xfm.path)) ? 'active' : ''"
                    class="bottom-nav-action-button"
                >
                    <i class="bi bi-file-earmark-plus" />
                </a>
            </div>
        </LocalScope>

        <LocalScope v-slot="{ scope: xfm }" :scope="flattenPanels.get('users')">
            <a
                v-if="xfm"
                class="bottom-nav-item"
                :href="formUrl(xfm.path)"
                :class="isActive(formUrl(xfm.path)) ? 'active' : ''"
            >
                <i class="bi bi-person-rolodex" />
                <span class="bottom-nav-label">{{ xfm.label }}</span>
            </a>
        </LocalScope>

        <LocalScope v-slot="{ scope: xfm }" :scope="flattenPanels.get('products')">
            <a
                v-if="xfm"
                class="bottom-nav-item"
                :href="formUrl(xfm.path)"
                :class="isActive(formUrl(xfm.path)) ? 'active' : ''"
            >
                <i class="bi bi-list-check" />
                <span class="bottom-nav-label">{{ xfm.label }}</span>
            </a>
        </LocalScope>

        <a
            v-if="hasMoreItems.length"
            href="#"
            class="bottom-nav-item"
            @click.prevent.stop=""
        >
            <img class="bottom-nav-icon" :src="`${ROOT}images/icons/toolbar2.png?${APP_VERSION_QS}`" alt="">
            <span class="bottom-nav-label">Altro</span>
        </a>
    </nav>
</template>

